import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_4: FaireProductEntity = {
  token: "nyc-acc-4",
  type: "product",
  name: "NYC Ceramic Coaster Set",
  brandName: "Queens Pottery",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
  priceDollars: 16,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 4,
    depth: 0.5,
  },
  description: "Handcrafted ceramic coasters from Queens",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "handmade", "ceramic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
